// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2t2YE","buttons":"Footer_buttons__tzSm-"};